<template>
  <v-form>
    <v-container>
      <v-card>
        <v-container>
          <v-card-title class="title-highlight">
            店舗一覧
          </v-card-title>

          <!-- 달력 -->
          <v-layout row wrap class="rowBox">
            <v-flex xs10 sm4>
              <v-menu
                v-model="menu"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="stocktakingDate"
                    label="棚卸日"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="stocktakingDate"
                  @input="menu = false"
                  locale="jp-ja"
                  :day-format="stocktakingDate => new Date(stocktakingDate).getDate()"
                  no-title
                ></v-date-picker>
              </v-menu>
            </v-flex>            
          </v-layout>

          <v-layout row wrap align-center>
            <v-flex xs12>
              <v-select
                v-model="selectSupplier"
                :items="suppliers"
                item-text="supplierName"
                item-value="supplierCode"
                return-object
                clearable
                label="取引先"
              ></v-select>
            </v-flex>

            <div style="height: 35px;"></div>

            <v-data-table
              :headers="headers"
              :items="stores"
              hide-actions
              class="elevation-1"
              :customFilter="customFilter"
              :custom-sort="customSort"
              :search="selectSupplier"
              style="width: 100%; margin: 15px 0 0;"
              :no-data-text="$t('noTableDataAvailable')"
              :loading="storeDataLoading"
            >
              <template slot="headerCell" slot-scope="props">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <span v-on="on">{{ props.header.text }}</span>
                  </template>
                  <span>{{ props.header.text }}</span>
                </v-tooltip>
              </template>
              <template v-slot:items="props">
                <tr v-bind:class="{'active-class-name': '1' === props.item.status}">
                  <td class="text-xs-left" @click="forwardStoreCompareStocktakingDetail(props.item)">
                    {{ props.item.storeName }}
                  </td>                  
                  <td class="text-xs-left" @click="forwardStoreCompareStocktakingDetail(props.item)">
                    {{ props.item.createdAt }}
                  </td>
                  <td class="text-xs-left" @click="forwardStoreCompareStocktakingDetail(props.item)">
                    {{ props.item.createdUser }}
                  </td>                  
                </tr>
              </template>
            </v-data-table>
          </v-layout>

          <div style="height: 25px;"></div>

          <v-layout row wrap>
            <v-flex xs12>
              <v-btn block color="#4C728A" dark :to="{ name: 'admin/new-admin-menu' }">
                <v-icon color="black" left>home</v-icon>Home
              </v-btn>
            </v-flex>            
          </v-layout>
        </v-container>
      </v-card>
    </v-container>
  </v-form>
</template>

<script>
import moment from 'moment-timezone'
import ServerApiCallService from '@/services/ServerApiCallService.js'

export default {
  created() {
    console.log('created')
    ServerApiCallService.setAppJs(this.$parent.$parent.$parent)
    
    this.getAliveStores()
  },
  methods: {
    getAliveStores() {
      console.log('getAliveStores')

      this.storeDataLoading = true

      // 모든 점포정보 가져오기
      ServerApiCallService.getAliveStores()
      .then(response => {
        this.stores = response.data.stores
        
        this.stores.forEach(item => {
          let supplier = {};
          supplier.supplierCode = item.supplierCode
          supplier.supplierName = item.supplierName

          this.suppliers.push(supplier);
        })
        
        this.storeDataLoading = false
      })
      .catch(error => {
        console.log('There was an error:', error.response)
      })
    },
    customFilter(items, search) {
      console.log('custom filter')

      if (!search.supplierCode) {
        return items
      } else {
        let filteringItems = items.filter(function(item) {
          if (item.supplierCode === search.supplierCode) {
            return true
          } else {
            return false
          }
        })

        return filteringItems
      }
    },
    customSort(items, index, isDesc) {
      items.sort((a, b) => {
        if (!isDesc) {
          if (a.storeName < b.storeName) {
            return -1
          } else if (a.storeName > b.storeName) {
            return 1
          }
        } else {
          if (a.storeName < b.storeName) {
            return 1
          } else if (a.storeName > b.storeName) {
            return -1
          }
        }
        return 0
      })
      return items
    },
    forwardStoreCompareStocktakingDetail(selectedStore) {
      this.$router.push({
        name: 'admin/store-compare-stocktaking-detail',
        params: {
          storeCode: selectedStore.storeCode,
          storeName: selectedStore.storeName,
          stocktakingDate: this.stocktakingDate
        }
      })
    }    
  },
  data() {
    return {
      stocktakingDate: moment().add(-1, 'days').format('YYYY-MM-DD'),
      storeDataLoading: false,
      menu: false,
      selectSupplier: [],
      suppliers: [],
      headers: [
        {
          text: '店舗名',
          align: 'left',
          value: 'storeName',
          width: '30%',
          sortable: false,
          fixed: false
        },        
        {
          text: '',
          align: 'left',
          value: 'createdAt',
          sortable: false,
          fixed: false
        },
        {
          text: '',
          align: 'left',
          value: 'createdUser',
          sortable: false,
          fixed: false
        }
      ],
      stores: []
    }
  }
}
</script>
<style>
.active-class-name {
  background-color: #d5ffc4;
}
.title-highlight {
  font-size: 20px;          /* 🔹 기본 타이틀보다 크게 */
  font-weight: bold;        /* 🔹 굵게 */
  color: #2c3e50;           /* 🔹 진한 남색 계열 */
  /*border-left: 5px solid #4C728A; /* 🔹 왼쪽에 포인트 라인 */
  padding-left: 10px;       /* 🔹 라인과 글자 사이 간격 */
  margin-bottom: 10px;      /* 🔹 아래 여백 */
}
</style>
